// Pure: given the authoritative instance row and my user id, what should the
// match-launch UI be? No side effects, no network. The single source of truth
// for ready-check / launch decisions. Events only trigger a re-derive.
//
// Returns { show, roomCode, resumed }:
//   'launchHost' | 'launchGuest'. Phase active + roomCode, I'm that seat
//   'readyCheck'. A ready-check window is open and I'm not ready
//   'none'. Nothing to show

export function deriveSessionView(instance, myId) {
  const none = { show: 'none', roomCode: null, resumed: false };
  if (!instance || !myId) return none;

  const me = (instance.participants || []).find((p) => p.userId === myId);
  if (!me) return none;

  // Active match takes priority. Launch into the room regardless of any
  // lingering ready-check marker.
  if (instance.phase === 'active' && instance.room_code) {
    const isHost = me.role === 'creator';
    return {
      show: isHost ? 'launchHost' : 'launchGuest',
      roomCode: instance.room_code,
      // A guest resumes (skips fresh spawn + opening draw, pulls existing
      // state) iff there is durable state to resume into. The host derives
      // resume from its own staged/disk blob and ignores this field.
      resumed: !!instance.has_snapshot,
    };
  }

  // Ready-check is open iff the durable deadline is set and not past, and I
  // haven't readied yet. Derivable from state. No event dependency.
  const deadline = instance.ready_check_deadline
    ? new Date(instance.ready_check_deadline).getTime()
    : 0;
  if (deadline > Date.now()) {
    return { show: 'readyCheck', roomCode: null, resumed: instance.phase === 'paused' };
  }

  return none;
}
